import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { listWorkspaces } from "@/workspace/cloud";
import { WorkspaceEditor } from "@/components/admin/workspaces/WorkspaceEditor";

export default function WorkspaceEditPage() {
  const { id } = useParams<{ id: string }>();
  const { data: workspaces, isLoading } = useQuery({
    queryKey: ["workspace_views"],
    queryFn: listWorkspaces,
  });

  if (isLoading) {
    return (
      <div className="px-6 py-6">
        <p className="text-sm text-muted-foreground">Loading workspace…</p>
      </div>
    );
  }

  const ws = workspaces?.find((w) => w.id === id);
  if (!ws) {
    return (
      <div className="px-6 py-6">
        <p className="text-sm text-destructive">Workspace not found.</p>
      </div>
    );
  }

  return <WorkspaceEditor initial={ws} />;
}
